import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core/utils';
import angular, { IFilterService, IQService, ITimeoutService } from 'angular';
import { PermissionsService } from '../../permissions';

export class CartEventsService {
  static $inject = [
    '$q',
    '$filter',
    '$timeout',
    'HelpersService',
    'ApiService',
    'CalendarService',
    'UserPreferencesService',
    'PermissionsService',
    'SalesRulesService',
    'EventTicketDisplayMax',
    'EventAddOnDisplayMax',
  ];
  model = [];
  parent = {} as {
    getTransactingMembershipCategory: () => any;
    getTransactingMembership: () => any;
    getTransactingMembershipId: () => any;
    setVerifyEntitlements: (ignoreLimits: boolean) => void;
    updateCart: () => Promise<any>;
    getEventItemById: (eventItem: any) => any;
    updateItem: (eventItem: any) => any;
    addItem: (eventItem: any) => any;
    removeItem: (itemId: any, skipGetCart: boolean) => any;
    removeItems: (itemIds: any) => any;
    addCartItem: (eventItem: any) => Promise<any>;
    updateCartItem: (eventItem: any) => Promise<any>;
    getReservationId: () => number;
    setReservation: (reservationId?: number) => void;
    getModel: () => any;
    getOrganization: () => any;
  };
  events: any[] = [];
  reservation: Partial<{ id: any; reservationItems: any[] }> | null = null;

  cartEventTicket = {
    itemId: '',
    eventId: '',
    ticketingTypeId: '',
    eventName: '',
    ticketingTypeName: '',
    quantity: 0,
    unitPrice: '0.00',
    retailUnitPrice: '0.00',
    amount: '0.00',
    itemType: 'Event',
    admissionType: '',
    isRetail: false,
    ignoreEntitlements: false,
    displayOrder: 1,
    resolvedQuantity: 0,
    ticketingTypeDescription: '',
    csrDisabled: 0,
    invalid: false,
    total: 0,
    maxLimit: 10,
    groupQuantity: 0,
  };

  dateFormat = this.UserPreferencesService.getDateFormat('standardDate', 'dateFormat');

  CODES = {
    errors: {
      RESERVATION_DNE: 1057, // Reservation not found
    },
  };

  constructor(
    private $q: IQService,
    private $filter: IFilterService,
    private $timeout: ITimeoutService,
    private HelpersService: TODO,
    private ApiService: ApiService,
    private CalendarService: TODO,
    private UserPreferencesService: TODO,
    private PermissionsService: PermissionsService,
    private SalesRulesService: TODO,
    private EventTicketDisplayMax: number,
    private EventAddOnDisplayMax: number
  ) {}

  init(parent) {
    this.parent = parent;
    return this;
  }

  addToCart(event) {
    const q = this.$q.defer();

    if ((event.tickets && event.tickets.length) || this.getAddOns(event).length) {
      this.addOrUpdateItems(event, event.tickets, 'Event');

      this.addOrUpdateItems(event, this.getAddOns(event), 'Inventory');

      if (event.hasOwnProperty('ignoreLimits')) {
        this.parent.setVerifyEntitlements(event.ignoreLimits);
      } else {
        this.parent.setVerifyEntitlements(false);
      }

      this.parent.updateCart().then(
        (response) => {
          q.resolve(response);
        },
        (response) => {
          q.reject(response);
        }
      );
    } else if (event.id) {
      //get event details first, then add up to top 5 ticket types(retail and member)/addOns to the cart
      this.eventDetail(event.id).then(
        (response: any) => {
          const eventData = this.processEvent(response.data.payload);
          let tickets = eventData.priceList.prices;
          const allTickets = eventData.priceList.prices;
          let addOns = eventData.addOns ? eventData.addOns.inventoryAddOns : [];
          const allAddOns = eventData.addOns ? eventData.addOns.inventoryAddOns : [];
          let existingItem;
          let eventItem;
          let item;

          if (this.PermissionsService.check('CSR')) {
            tickets = tickets.filter((ticket) => {
              return !ticket.csrDisabled;
            });
          }

          //if there are no csr enabled tickets, add non-csr tickets
          if (!tickets.length) {
            tickets = allTickets;
          }

          if (this.PermissionsService.check('CSR')) {
            addOns = addOns.filter((ticket) => {
              return !ticket.csrDisabled;
            });
          }

          //if there are no csr enabled addOns, add non-csr addOns
          if (!addOns.length) {
            addOns = allAddOns;
          }

          const maxTickets = Math.min(this.EventTicketDisplayMax, tickets.length);
          const maxAddOns = Math.min(this.EventAddOnDisplayMax, addOns.length);

          for (let i = 0, ii = maxTickets; i < ii; i++) {
            item = tickets[i];
            existingItem = item.itemId && this.parent.getEventItemById(item);
            eventItem = {
              quantity: item.quantity || 0,
              isRetail: item.isRetail || false,
              itemType: 'Event',
              eventId: event.id,
              displayOrder: item.displayOrder || 0,
              ticketingTypeId: item.personType.id || null,
              ticketingTypeName: item.personType.name || null,
              unitPrice: item.discountedPrice || null,
              retailUnitPrice: item.price || null,
              ignoreEntitlements: item.isRetail ? false : event.ignoreLimits,
            };
            if (existingItem) {
              eventItem.itemId = existingItem.itemId;
              this.parent.updateItem(eventItem);
            } else {
              this.parent.addItem(eventItem);
              //also add a retail version of this item.
              //TODO: Refactor this later to be more ad-hoc later.
              this.parent.addItem(angular.extend({}, eventItem, { isRetail: true }));
            }
          }

          for (let i = 0, ii = maxAddOns; i < ii; i++) {
            item = addOns[i];
            existingItem = item.itemId && this.parent.getEventItemById(item);
            eventItem = {
              quantity: item.quantity || 0,
              itemType: 'Inventory',
              eventId: event.id,
              displayOrder: item.displayOrder || 0,
              inventoryId: item.id || null,
              inventoryName: item.name || null,
              unitPrice: item.price || null,
              retailUnitPrice: item.price || null,
            };
            if (existingItem) {
              eventItem.itemId = existingItem.itemId;
              this.parent.updateItem(eventItem);
            } else {
              this.parent.addItem(eventItem);
            }
          }

          this.parent.updateCart().then(
            (response) => {
              q.resolve(response);
            },
            (response) => {
              q.reject(response);
            }
          );
        },
        (response) => {
          q.reject(response);
        }
      );
    } else {
      q.reject();
    }

    return q.promise;
  }

  addOrUpdateItems(event, items, itemType) {
    if (items.length && items[0] && items.displayOrder >= 0) {
      items.sort((a, b) => {
        return a.displayOrder - b.displayOrder;
      });
    }

    angular.forEach(items, (item) => {
      const existingItem = item.itemId && this.parent.getEventItemById(item);
      // TODO: remove any
      const eventItem: any = {
        quantity: item.quantity || 0,
        isRetail: item.isRetail || false,
        itemType: itemType,
        eventId: event.eventId,
        displayOrder: item.displayOrder || 0,
        ticketingTypeId: item.ticketingTypeId || null,
        inventoryId: item.inventoryId || null,
        ticketingTypeName: item.ticketingTypeName || null,
        inventoryName: item.inventoryName || null,
        unitPrice: item.inventoryId ? item.price || null : item.unitPrice || null,
        retailUnitPrice: item.inventoryId ? item.price || null : item.retailUnitPrice || null,
        ignoreEntitlements: item.isRetail ? false : event.ignoreLimits,
      };
      if (existingItem) {
        eventItem.itemId = existingItem.itemId;
        if (item.invalid) {
          this.parent.removeItem(eventItem.itemId, true);
        } else {
          this.parent.updateItem(eventItem);
        }
      } else {
        this.parent.addItem(eventItem);
      }
    });
  }

  isEventDiscounted(event, fromMembership = false) {
    let hasDiscount = false;
    const prices = event.event && event.event.priceList.prices ? event.event.priceList.prices : [];

    for (let i = 0, ii = prices.length; i < ii; i++) {
      if (this.isTicketDiscounted(prices[i], event, fromMembership)) {
        hasDiscount = true;
        break;
      }
    }

    return hasDiscount;
  }

  isTicketDiscounted(ticket, event, fromMembership = false) {
    const found = this.findTicketType({
      ticket: ticket,
      isRetail: false,
      tickets: event.event.priceList.prices,
    });

    if (!found) {
      return false;
    }

    if (fromMembership) {
      return this.hasMembershipDiscount(found);
    } else {
      return this.hasMembershipDiscount(found) || this.hasCouponDiscount(found);
    }
  }

  /**
   * // TODO: This is a temporary workaround to show discounted ticket prices inside the "retail" tab.
   * We have to do this because coupons are applied to the whole order. It will be possible to remove
   * this logic once we support line item coupons.
   */
  isTicketDiscountedWithCoupon(ticket, event) {
    const found = this.findTicketType({
      ticket: ticket,
      isRetail: true,
      tickets: event.tickets,
    });

    return this.hasCouponDiscount(found);
  }

  hasMembershipDiscount(found) {
    if (!found) {
      return false;
    }

    return (
      found.ticket.price != null &&
      found.ticket.discountedPrice != null &&
      found.ticket.price !== found.ticket.discountedPrice
    );
  }

  hasCouponDiscount(found) {
    if (!found) {
      return false;
    }

    return (
      found.ticket.retailUnitPrice != null &&
      found.ticket.unitPrice != null &&
      found.ticket.retailUnitPrice !== found.ticket.unitPrice
    );
  }

  isRetailTicketWithQuantity(ticket) {
    return ticket.isRetail && ticket.quantity;
  }

  findTicketType(args: { ticket: any; isRetail: boolean; tickets: any[] }) {
    let isTicketRetail;
    let result: { index: number; ticket: { quantity: number } } | null = null;

    for (let i = 0, ii = args.tickets.length; i < ii; i++) {
      isTicketRetail = args.tickets[i].isRetail || false;

      if (args.tickets[i].ticketingTypeId === args.ticket.ticketingTypeId && isTicketRetail === args.isRetail) {
        result = {
          index: i,
          ticket: args.tickets[i],
        };

        break;
      }
    }

    return result;
  }

  // if event is no longer discounted:
  // set previously discounted ticket quantities a sum of discounted and their retail counterparts
  // and set retail tickets (on top of discounted) quantities to 0.
  removeDiscountedTickets(event, fromMembership = false) {
    let updateCart = false;
    const q = this.$q.defer();
    const isDiscounted = this.isEventDiscounted(event, fromMembership);
    const tickets = isDiscounted ? [] : event.tickets.filter(this.isRetailTicketWithQuantity);

    if (tickets.length) {
      updateCart = true;
    }
    angular.forEach(tickets, (ticket) => {
      const found = this.findTicketType({
        ticket: ticket,
        isRetail: false,
        tickets: event.tickets,
      });

      if (found) {
        found.ticket.quantity = found.ticket.quantity + ticket.quantity;
        this.addOrUpdateItems(event, [found.ticket], 'Event');
      }

      ticket.quantity = 0;
      this.addOrUpdateItems(event, [ticket], 'Event');
    });

    if (updateCart) {
      this.parent.updateCart().then(
        (response) => {
          q.resolve(response);
        },
        (response) => {
          q.reject(response);
        }
      );
    } else {
      q.resolve();
    }

    return q.promise;
  }

  switchEvent(event, changeEvent) {
    const found = this.getById(event.eventId);
    const q = this.$q.defer();

    if (found) {
      //switch eventId,remove all ticket types that don't exist on the new event.
      angular.forEach(event.tickets, (ticket) => {
        ticket.invalid = !this.checkEventHasTicket(ticket, changeEvent);
        ticket.eventId = changeEvent.id;
      });

      this.checkAndAddTickets(event, changeEvent);

      angular.forEach(this.getAddOns(event), (addOn) => {
        addOn.invalid = !this.checkEventHasAddOn(addOn, changeEvent);
        addOn.eventId = changeEvent.id;
      });

      this.events[found.index].eventId = changeEvent.id;

      return this.addToCart(event);
    } else {
      q.reject();
    }

    return q.promise;
  }

  updateItem(item) {
    const q = this.$q.defer();
    const found = this.getById(item.eventId);
    const existingItem = item.itemId && this.parent.getEventItemById(item);
    // TODO: remove any
    const eventItem: any = {
      quantity: item.quantity || 0,
      isRetail: item.isRetail || false,
      itemType: item.inventoryId ? 'Inventory' : 'Event',
      eventId: item.eventId,
      displayOrder: item.displayOrder || 0,
      ticketingTypeId: item.ticketingTypeId || null,
      inventoryId: item.inventoryId || null,
      ticketingTypeName: item.ticketingTypeName || null,
      inventoryName: item.inventoryName || null,
      unitPrice: item.unitPrice || null,
      retailUnitPrice: item.inventoryId ? item.unitPrice || null : item.retailUnitPrice || null,
      ignoreEntitlements: item.isRetail ? false : item.ignoreEntitlements,
    };
    if (found) {
      eventItem.ignoreEntitlements = this.events[found.index].ignoreLimits;
    }
    if (existingItem) {
      eventItem.itemId = existingItem.itemId;
      if (item.invalid) {
        this.parent.removeItem(eventItem.itemId, true);
      } else {
        this.parent.updateItem(eventItem);
      }
      this.parent.updateCartItem(eventItem).then(
        (response) => {
          // Call Reservation update in case we have pre-populated events
          if (eventItem.itemType === 'Event') {
            this.updateReservation();
          }
          q.resolve(response);
        },
        (response) => {
          q.reject(response);
        }
      );
    }

    return q.promise;
  }

  addItem(item): Promise<any> {
    const q = this.$q.defer();
    const found = this.getById(item.eventId);
    // TODO: remove any
    const eventItem: any = {
      quantity: item.quantity || 0,
      isRetail: item.isRetail || false,
      itemType: item.inventoryId ? 'Inventory' : 'Event',
      eventId: item.eventId,
      displayOrder: item.displayOrder || 0,
      ticketingTypeId: item.ticketingTypeId || null,
      inventoryId: item.inventoryId || null,
      ticketingTypeName: item.ticketingTypeName || null,
      inventoryName: item.inventoryName || null,
      unitPrice: item.unitPrice || null,
      retailUnitPrice: item.inventoryId ? item.unitPrice || null : item.retailUnitPrice || null,
      ignoreEntitlements: item.isRetail ? false : item.ignoreEntitlements,
    };

    if (found) {
      eventItem.ignoreEntitlements = this.events[found.index].ignoreLimits;
    }

    this.parent.addCartItem(eventItem).then(
      (response) => {
        eventItem.itemId = response.data.payload;
        this.parent.addItem(eventItem);
        // Call Reservation update in case we have pre-populated events
        if (eventItem.itemType === 'Event') {
          this.updateReservation();
        }
        q.resolve(response);
      },
      (response) => {
        q.reject(response);
      }
    );

    return q.promise as Promise<any>;
  }

  eventDetail(eventId) {
    const q = this.$q.defer();
    const membershipLevelIds = this.parent.getTransactingMembershipCategory();
    const membershipId = this.parent.getTransactingMembershipId();

    this.ApiService.event
      .detail(eventId, { membershipCategoryId: membershipLevelIds, membershipId: membershipId })
      .then(
        (response) => {
          q.resolve(response);
        },
        (response) => {
          q.reject(response);
        }
      );

    return q.promise;
  }

  eventMembershipDetail(eventTemplateId) {
    const q = this.$q.defer();

    this.ApiService.program.template.published(eventTemplateId).then(
      (response) => {
        q.resolve(response);
      },
      (response) => {
        q.reject(response);
      }
    );

    return q.promise;
  }

  setModel(data) {
    const eventsInCart = {};
    let found;
    let eventDetailId;
    let eventId;

    this.model = data;

    if (data instanceof Array && data.length) {
      //bucket each item into it's event
      angular.forEach(data, (item) => {
        if (item.eventId) {
          if (item.itemType === 'Event') {
            eventsInCart[item.eventId] = this.addTicket(item, eventsInCart[item.eventId]);
          }
          if (item.itemType === 'Inventory') {
            eventsInCart[item.eventId] = this.addAddon(item, eventsInCart[item.eventId]);
          }
        }
      });

      //remove any events that don't exist in the cart
      this.events = this.getEvents().filter((event) => {
        return eventsInCart.hasOwnProperty(event.eventId) && eventsInCart[event.eventId];
      });

      //add or update remaining events with current tickets from cart
      for (eventId in eventsInCart) {
        if (eventsInCart.hasOwnProperty(eventId) && eventsInCart[eventId]) {
          eventsInCart[eventId].ignoreLimits = this.SalesRulesService.getIgnoreTicketLimits(eventsInCart[eventId]);

          found = this.getById(eventId);
          if (found) {
            this.events[found.index] = angular.extend(found.event, eventsInCart[eventId]);
            eventDetailId = this.events[found.index].event && this.events[found.index].event.id;

            if (eventDetailId && eventDetailId === eventId) {
              this.updateTickets(this.events[found.index]);
              this.updateAddOns(this.events[found.index]);
            }
          } else {
            this.events.push(eventsInCart[eventId]);
          }
        }
      }
    } else {
      this.clearModel();
    }
  }

  getReservation() {
    const q = this.$q.defer();

    if (this.parent.getReservationId()) {
      this.ApiService.reservations.detail(this.parent.getReservationId()).then(
        (response) => {
          q.resolve(response);
        },
        (response) => {
          q.reject(response);
        }
      );
    } else {
      this.createReservation().then(
        (response) => {
          q.resolve(response);
        },
        (response) => {
          q.reject(response);
        }
      );
    }

    return q.promise;
  }

  setReservation(reservation?: any) {
    this.reservation = reservation;
    if (this.reservation) {
      this.parent.setReservation(this.reservation.id);
    } else {
      this.parent.setReservation();
    }
  }

  updateReservation() {
    let latestReservation;
    const createNewReservation = () => {
      //Reservation was not found or expired, try to create one.
      this.createReservation(latestReservation.reservationItems)
        .then((response) => this.onReservationSuccess(response))
        .catch((response) => this.onReservationError(response));
    };

    if (!this.reservation) {
      this.reservation = {};
    }

    const latestReservationItems = this.getReservationItems();
    const hasChanged = JSON.stringify(latestReservationItems) !== JSON.stringify(this.reservation.reservationItems);

    if (hasChanged) {
      latestReservation = {
        id: this.reservation.id,
        reservationItems: latestReservationItems,
      };

      if (latestReservation.id) {
        this.ApiService.reservations
          .update(latestReservation)
          .then((response) => this.onReservationSuccess(response))
          .catch((response) => {
            const responseErrorData = response.errorData;

            if (
              responseErrorData &&
              responseErrorData.errorCode &&
              responseErrorData.errorCode === this.CODES.errors.RESERVATION_DNE
            ) {
              createNewReservation();
            } else {
              this.onReservationError(response);
            }
          });
      } else {
        createNewReservation();
      }
    }
  }

  getReservationItems() {
    const events = this.getEvents();
    let reservationItems: any[] = [];
    this.getEvents().map((event) => {
      const currentReservation = this.getTicketMap(event.eventId);
      reservationItems = reservationItems.concat(currentReservation);
    });
    return reservationItems;
  }

  onReservationSuccess(updatedReservation) {
    // Consider extra meta-data in reservation items from response
    // i.e. id, and reservationId - need to send? need to keep?
    const updatedReservationItems = updatedReservation.payload.reservationItems.map((event) => {
      return {
        quantity: event.quantity,
        eventId: event.eventId,
      };
    });

    // Update local reservation on success
    if (this.reservation) {
      Object.assign(this.reservation, {
        expirationTimestamp: updatedReservation.payload.expirationTimestamp, // Keep for future use
        reservationItems: updatedReservationItems,
      });
    }

    this.resetEventReservationErrors();
  }

  setReservationError(eventId, errorData) {
    const event = this.getEvents().filter((event) => {
      return event.eventId === eventId;
    });

    if (event[0]) {
      event[0].reservationError = errorData;
    }
  }

  onReservationError(response: { errorData: { eventId: TODO; requested: TODO; available: TODO } }) {
    const errorData = this.getReservationError(response.errorData);

    if (response.errorData && response.errorData.eventId) {
      this.resetEventReservationErrors();
      this.setReservationError(response.errorData.eventId, errorData);
    }
  }

  getReservationError(errorData: { eventId: TODO; requested: TODO; available: TODO }) {
    const currentReservationForErroringEvent =
      this.reservation?.reservationItems?.filter((event) => {
        return event.eventId === errorData.eventId;
      }) ?? [];
    const numberTicketsRequested = parseInt(errorData.requested, 10);
    let numberTicketsReserved = 0;

    // Get number of tickets currently reserved, if any
    if (currentReservationForErroringEvent[0]) {
      numberTicketsReserved = parseInt(currentReservationForErroringEvent[0].quantity, 10);
    }

    const requested = numberTicketsRequested + numberTicketsReserved;
    const available = errorData.available + numberTicketsReserved;

    return { requested, available };
  }

  resetEventReservationErrors() {
    angular.forEach(this.getEvents(), (event) => {
      event.reservationError = false;
    });
  }

  hasReservation() {
    return this.reservation;
  }

  createReservation(reservationItems = []) {
    const q = this.$q.defer();
    // Setup Reservation
    this.ApiService.reservations.create(reservationItems).then(
      (reservationResponse) => {
        this.setReservation(reservationResponse.payload);
        //update the cart with the new reservationId before returning the reservation response
        this.parent.updateCart().then(
          () => {
            q.resolve(reservationResponse);
          },
          () => {
            q.reject(reservationResponse);
          }
        );
      },
      (response) => {
        q.reject(response);
      }
    );
    return q.promise;
  }

  cancelReservation() {
    // If this is null, then we've either not initialised or we've completed the transaction
    if (this.reservation && this.reservation.id) {
      this.ApiService.reservations.cancel(this.reservation.id);
      this.reservation = null;
      this.parent.setReservation();
    }
  }

  getModel() {
    return this.model;
  }

  resetModel() {
    this.model = [];
    this.events = [];
    this.SalesRulesService.resetLimits();
    this.cancelReservation();
  }

  clearModel() {
    this.model = [];
    this.events = [];
    this.SalesRulesService.resetLimits();
  }

  getEvents() {
    return this.events;
  }

  getById(id) {
    let result: { index: number; event: any } | false = false;

    for (let i = 0, ii = this.events.length; i < ii; i++) {
      if (this.events[i].eventId === id) {
        result = {
          event: this.events[i],
          index: i,
        };
        break;
      }
    }
    return result;
  }

  //return sum of quantities for all event instances coming from the same event template that occur on the same day.
  //returns only if there are multiple times of the same event on the same day.
  getSameDayEventTicketQuantities() {
    const sameDayEventTicketQuantities = {};
    const eventMap = {};
    let events;
    let key;
    const updateTicketQuantities = (event) => {
      angular.forEach(event.tickets, (ticket) => {
        let key = ticket.ticketingTypeId;

        if (ticket.quantity) {
          key = ticket.isRetail ? key + '-retail' : key + '-regular';
          if (sameDayEventTicketQuantities[key]) {
            sameDayEventTicketQuantities[key].quantity = sameDayEventTicketQuantities[key].quantity + ticket.quantity;
          } else {
            sameDayEventTicketQuantities[key] = {};
            sameDayEventTicketQuantities[key].quantity = ticket.quantity;
          }
        }
      });
    };

    //go through the events and get the ones that have the same template id and start time
    angular.forEach(this.getEvents(), (event) => {
      const startDate = event.event.startDate;
      const key = event.event.templateId + '-' + startDate;

      if (!eventMap[key]) {
        eventMap[key] = {
          events: [event],
        };
      } else {
        eventMap[key].events.push(event);
      }
    });

    for (key in eventMap) {
      if (eventMap[key] && eventMap[key].events.length > 1) {
        events = eventMap[key].events;
        for (let i = 0, ii = events.length; i < ii; i++) {
          updateTicketQuantities(events[i]);
        }
      }
    }

    return this.HelpersService.isEmptyObject(sameDayEventTicketQuantities) ? null : sameDayEventTicketQuantities;
  }

  getEventTicketCount(id) {
    const found = this.getById(id);
    const event = found ? found.event : null;
    let result = 0;

    if (event) {
      result = event.tickets.reduce((count, item) => {
        let quantity = parseInt(item.quantity, 10);
        if (isNaN(quantity)) {
          quantity = 0;
        }
        return quantity + count;
      }, 0);
    }

    return result;
  }

  getTicketMap(id) {
    const found = this.getById(id);
    const event = found ? found.event : null;
    const result: { eventId: any; personType: any; quantity: number }[] = [];

    if (event) {
      for (const index in event.tickets) {
        const quantity = parseInt(event.tickets[index].quantity, 10);

        if (!isNaN(quantity)) {
          result.push({
            eventId: id,
            personType: event.tickets[index].ticketingTypeId,
            quantity: quantity,
          });
        }
      }
    }

    return result;
  }

  getDiscountedEventTicketCount(id) {
    const found = this.getById(id);
    const event = found ? found.event : null;
    let result = 0;

    if (event) {
      result = event.tickets.reduce((count, item) => {
        let quantity = 0;
        const isDiscounted = this.isTicketDiscounted(item, event);

        if (!item.isRetail && isDiscounted) {
          quantity = parseInt(item.quantity, 10);
          if (isNaN(quantity)) {
            quantity = 0;
          }
        }

        return quantity + count;
      }, 0);
    }

    return result;
  }

  getFullPriceEventTicketCount(id) {
    const found = this.getById(id);
    const event = found ? found.event : null;
    let result = 0;

    if (event) {
      result = event.tickets.reduce((count, item) => {
        let quantity = 0;
        const isDiscounted = this.isTicketDiscounted(item, event);

        if (item.isRetail || !isDiscounted) {
          quantity = parseInt(item.quantity, 10);
          if (isNaN(quantity)) {
            quantity = 0;
          }
        }

        return quantity + count;
      }, 0);
    }

    return result;
  }

  getAddOns(event) {
    return event.addOns ? event.addOns : [];
  }

  getEventAddOnCount(id) {
    const found = this.getById(id);
    const event = found ? found.event : null;
    let result = 0;

    if (event) {
      result = this.getAddOns(event).reduce((count, item) => {
        let quantity = parseInt(item.quantity, 10);
        if (isNaN(quantity)) {
          quantity = 0;
        }
        return quantity + count;
      }, 0);
    }

    return result;
  }

  checkEventHasTicket(ticket, event) {
    let result: { index: number; price: number } | null = null;
    for (let i = 0, ii = event.priceList.prices.length; i < ii; i++) {
      if (event.priceList.prices[i].personType.id === ticket.ticketingTypeId) {
        result = {
          index: i,
          price: event.priceList.prices[i],
        };
        break;
      }
    }

    return result;
  }

  checkAndAddTickets(event, changeEvent) {
    const cartTicketObject = Object.assign({}, this.cartEventTicket);

    changeEvent.priceList.prices
      .map((ticket) => {
        return Object.assign({}, cartTicketObject, {
          eventId: event.id,
          ticketingTypeId: ticket.personType.id,
          ticketingTypeName: ticket.personType.name,
          ticketingTypeDescription: ticket.personType.description,
          displayOrder: ticket.displayOrder,
          unitPrice: ticket.price,
          retailUnitPrice: ticket.price,
        });
      })
      .forEach((ticket) => {
        let ticketFound = false;

        if (event.tickets && event.tickets.length) {
          ticketFound = event.tickets.find((eventTicket) => {
            return ticket.ticketingTypeId === eventTicket.ticketingTypeId;
          });
        }

        if (!ticketFound) {
          event.tickets.push(ticket);
        }
      });
  }

  checkEventHasAddOn(addOn, event) {
    let result: { index: number; addOn: any } | null = null;
    const addOns = event.addOns ? event.addOns.inventoryAddOns : [];
    for (let i = 0, ii = addOns.length; i < ii; i++) {
      if (addOns[i].id === addOn.inventoryId) {
        result = {
          index: i,
          addOn: addOns[i],
        };
        break;
      }
    }

    return result;
  }

  addTicket(ticket, event) {
    let result: { eventId: any; tickets: any[]; addOns: any[]; itemType: any } | null = null;
    let found;

    if (event) {
      if (!(event.tickets instanceof Array)) {
        event.tickets = [];
      }
      for (let i = 0, ii = event.tickets.length; i < ii; i++) {
        if (
          event.tickets[i].ticketingTypeId === ticket.ticketingTypeId &&
          event.tickets[i].isRetail === ticket.isRetail
        ) {
          found = true;
          event.tickets[i].quantity = ticket.quantity;
          event.tickets[i].resolvedQuantity = ticket.quantity;
          break;
        }
      }
      if (!found) {
        event.tickets.push(angular.extend(ticket, { resolvedQuantity: ticket.quantity }));
      }
      result = event;
    } else {
      result = {
        eventId: ticket.eventId,
        tickets: [angular.extend(ticket, { resolvedQuantity: ticket.quantity })],
        addOns: [],
        itemType: 'event',
      };
    }

    return result;
  }

  addAddon(addOn, event) {
    let result: { eventId: any; tickets: any[]; addOns: any[]; itemType: any } | null = null;
    let found;

    if (event) {
      if (!(event.addOns instanceof Array)) {
        event.addOns = [];
      }
      for (let i = 0, ii = event.addOns.length; i < ii; i++) {
        if (event.addOns[i].inventoryId === addOn.inventoryId) {
          found = true;
          event.addOns[i].quantity = addOn.quantity;
          event.addOns[i].resolvedQuantity = addOn.quantity;
          break;
        }
      }
      if (!found) {
        event.addOns.push(angular.extend(addOn, { resolvedQuantity: addOn.quantity }));
      }
      result = event;
    } else {
      result = {
        eventId: addOn.eventId,
        addOns: [angular.extend(addOn, { resolvedQuantity: addOn.quantity })],
        tickets: [],
        itemType: 'event',
      };
    }

    return result;
  }

  setEventDetail(id, event) {
    const found = this.getById(id);
    if (found) {
      this.events[found.index].event = this.processEvent(event);
      this.updateTickets(this.events[found.index]);
      this.updateAddOns(this.events[found.index]);
    }
  }

  updateTickets(event) {
    angular.forEach(event.tickets, (ticket) => {
      const prices = event.event && event.event.priceList.prices ? event.event.priceList.prices : [];
      let found;
      for (let i = 0, ii = prices.length; i < ii; i++) {
        if (prices[i].personType.id === ticket.ticketingTypeId) {
          ticket.ticketingTypeDescription = prices[i].personType.description;
          ticket.csrDisabled = prices[i].csrDisabled;
          found = true;
          ticket.invalid = false;

          /**
           * Update price list with updated ticket prices coming from cart.
           * These prices already take coupons into account.
           * @link https://acmeticketing.atlassian.net/browse/ENG-13483
           */
          prices[i].unitPrice = ticket.unitPrice;
          prices[i].retailUnitPrice = ticket.retailUnitPrice;
          break;
        }
      }
      if (!found) {
        //This ticket type doesn't exist on the event. It is invalid, must be removed.
        ticket.invalid = true;
        ticket.quantity = 0;
      }
    });
  }

  updateAddOns(event) {
    angular.forEach(event.addOns || [], (addOn) => {
      let found;
      const addOns = event.event && event.event.addOns ? event.event.addOns.inventoryAddOns : [];

      for (let i = 0, ii = addOns.length; i < ii; i++) {
        if (addOns[i].id === addOn.inventoryId) {
          addOn.description = addOns[i].description;
          addOn.csrDisabled = addOns[i].csrDisabled;
          found = true;
          addOn.invalid = false;
          break;
        }
      }
      if (!found) {
        //This addon doesn't exist on the event. It is invalid, must be removed.
        addOn.invalid = true;
        addOn.quantity = 0;
      }
    });
  }

  setEventMembershipDetail(id, data) {
    const found = this.getById(id);
    if (found && this.events[found.index].event && data) {
      this.events[found.index].event.memberRestriction = this.processEventMemberRestriction(data);
    }
  }

  processEvent(event) {
    event = this.normalizeEventDate(event);

    if (this.PermissionsService.check('CSR')) {
      if (event.priceList) {
        angular.forEach(event.priceList.prices, (price) => {
          // TODO: remove any
          const filtered = (this.$filter('saleChannel') as any)([price], '!customerRep');
          price.csrDisabled = filtered.length;
        });
        // Split into 2 groups CSR vs Normal
        const normal = event.priceList.prices
          .filter((val) => {
            return val.csrDisabled;
          })
          .sort(this.sortByDisplayOrder);
        const csr = event.priceList.prices
          .filter((val) => {
            return !val.csrDisabled;
          })
          .sort(this.sortByDisplayOrder);
        // Join them in the correct split order
        event.priceList.prices = [].concat(csr.slice(0), normal.slice(0));
      }

      if (event.addOns) {
        angular.forEach(event.addOns.inventoryAddOns, (addOn) => {
          // TODO: remove any
          const filtered = (this.$filter('saleChannel') as any)([addOn], '!customerRep');
          if (filtered.length) {
            addOn.csrDisabled = true;
          }
        });
        event.addOns.inventoryAddOns = event.addOns.inventoryAddOns.sort(this.sortByCSR);
      }
    }

    return event;
  }

  normalizeEventDate(event) {
    event.startDate = this.$filter('date')(
      this.CalendarService.parseDate(event.startTime),
      this.UserPreferencesService.getDateFormat('standardDate', 'dateFormat')
    );
    event.startHour = this.$filter('date')(
      this.CalendarService.parseDate(event.startTime),
      this.UserPreferencesService.getDateFormat('standardTime', 'hourFormat')
    );

    return event;
  }

  processEventMemberRestriction(data) {
    const memberOnlyEvent = data && data.memberOnlyEvent;
    const allMembersCanPurchase = data && data.allMembersCanPurchase;
    let membershipLevels = [];

    if (memberOnlyEvent && !allMembersCanPurchase) {
      if (data.membership && data.membership.restrictions instanceof Array) {
        membershipLevels = data.membership.restrictions.map((restriction) => {
          return {
            auxiliary: restriction.auxiliary,
            id: restriction.id,
            membershipLevelGroup: restriction.membershipLevelGroup,
            name: restriction.name,
          };
        });
      }
    }

    return memberOnlyEvent
      ? {
          memberOnlyEvent: memberOnlyEvent,
          restricted: !allMembersCanPurchase,
          membershipLevels: membershipLevels,
        }
      : null;
  }

  //if there is at least one membership level in the cart or there is a transacting member, check restrictions for the event
  //The membership level in the cart or the membership level of the transacting member must match the restrictions for the event.

  validateMemberRestriction(eventId) {
    const membershipLevelIds = this.parent.getTransactingMembershipCategory();
    const membership = this.parent.getTransactingMembership();
    const membershipId = this.parent.getTransactingMembershipId();
    let memberRestriction;
    let isValid = true;
    const found = this.getById(eventId);
    let matchedLevels = [];
    const matchMembershipId = (membershipLevel) => {
      return membershipLevelIds === membershipLevel.id || (membership && membership.categoryId === membershipLevel.id);
    };

    if (found) {
      memberRestriction = found.event.event.memberRestriction;

      if (memberRestriction && memberRestriction.memberOnlyEvent && memberRestriction.restricted) {
        //restricted, so there has to be either a non-expired valid membership or a membership level in the cart
        if (membershipLevelIds || (membershipId && membership && membership.categoryId)) {
          matchedLevels = memberRestriction.membershipLevels.filter(matchMembershipId);
          isValid = matchedLevels.length > 0;
        } else {
          isValid = false;
        }
      }
    }

    return isValid;
  }

  sortByCSR(a, b) {
    let result = 0;
    if (a.csrDisabled && !b.csrDisabled) {
      result = 1;
    } else {
      result = -1;
    }

    return result;
  }

  sortByDisplayOrder(a, b) {
    return a.displayOrder && b.displayOrder ? a.displayOrder - b.displayOrder : 0;
  }

  remove(eventId) {
    const found = this.getById(eventId);
    const q = this.$q.defer();
    const itemIds: any[] = [];

    if (found) {
      if (found.event.tickets.length) {
        angular.forEach(found.event.tickets, (ticket) => {
          if (ticket.itemId) {
            itemIds.push(ticket.itemId);
          }
        });
      }
      if (found.event.addOns.length) {
        angular.forEach(found.event.addOns, (addOn) => {
          if (addOn.itemId) {
            itemIds.push(addOn.itemId);
          }
        });
      }

      this.parent.removeItems(itemIds);
      this.events.splice(found.index, 1);

      this.parent.updateCart().then(
        (response) => {
          //remove event from events list
          this.updateReservation();
          q.resolve(response);
        },
        (response) => {
          q.reject(response);
        }
      );
    } else {
      q.reject();
    }

    return q.promise;
  }

  salesRulesSuccess(data) {
    const limitsData = data;
    let limits = [];

    if (limitsData.violations instanceof Array) {
      limits = limitsData.violations;
    }

    if (limits instanceof Array) {
      this.SalesRulesService.processSalesRulesLimits(limits);
    }

    angular.forEach(this.getEvents(), (event) => {
      event.limitsChecked = true;
      this.SalesRulesService.updateTicketLimits(event, this.getSameDayEventTicketQuantities());
    });
  }

  salesRulesError(response) {
    this.SalesRulesService.processSalesRulesLimits([]);
    angular.forEach(this.getEvents(), (event) => {
      this.SalesRulesService.updateTicketLimits(event, this.getSameDayEventTicketQuantities());
    });
  }

  validateSalesRules(event) {
    const q = this.$q.defer();
    //TODO: Check limits is per cart right now, not per event. Should BE handle this?
    // checkLimits = event ? this.SalesRulesService.hasSalesRules([event]) : this.hasSalesRules(this.getEvents()),
    const checkLimits = this.hasSalesRules(this.getEvents());
    const cart = this.parent.getModel();

    if (cart && cart.id && checkLimits) {
      this.ApiService.entitlements
        .validateSalesRules({
          shoppingCartId: cart.id,
        })
        .then(
          (response) => {
            this.salesRulesSuccess(response.data.payload);
            q.resolve();
          },
          (response) => {
            this.salesRulesError(response);
            q.reject();
          }
        );
    } else {
      q.resolve();
    }

    return q.promise;
  }

  hasSalesRules(events) {
    const hasSalesRules = true;

    //TODO: We don't have indication of whether sales rules exist on event instances, only on event templates.
    // angular.forEach(events, function(event) {
    //   if (event.event) {
    //     hasSalesRules = this.SalesRulesService.hasSalesRules(event.event);
    //   }
    // });

    return hasSalesRules;
  }

  updateTicketLimitExceptions(event: TODO) {
    const found = this.getById(event.eventId);
    const q = this.$q.defer();

    if (found) {
      angular.forEach(event.tickets, (ticket) => {
        if (!ticket.isRetail) {
          ticket.ignoreEntitlements = event.ignoreLimits;
        } else {
          ticket.ignoreEntitlements = false;
        }
      });

      return this.addToCart(event);
    } else {
      q.reject();
    }

    return q.promise;
  }

  getOrganizationOrder() {
    const organization = this.parent.getOrganization();
    const organizationId = organization.id;
    const cartEvents = this.getEvents();
    let events: any[] = [];
    const promises = cartEvents.map((cartEvent) => {
      return this.ApiService.partners.reseller.event({ accountId: organizationId, eventId: cartEvent.event.id });
    });

    this.$q.all(promises).then(
      (responses) => {
        angular.forEach(responses, (response) => {
          events.push(response.data.payload);
        });
      },
      (response) => {
        //getting discounted prices for the org failed, proceed with full priced events
        cartEvents.forEach((cartEvent) => {
          events.push(cartEvent.event);
        });
      }
    );

    events = events.sort((a, b) => {
      const aDate = this.CalendarService.parseDate(a.eventStartDate || a.startTime).getTime();
      const bDate = this.CalendarService.parseDate(b.eventStartDate || a.startTime).getTime();
      let result = 0;

      if (!isNaN(aDate) && !isNaN(bDate)) {
        if (aDate > bDate) {
          result = 1;
        } else if (aDate < bDate) {
          result = -1;
        }
      }

      return result;
    });

    return {
      events: events,
      organizationId: organizationId,
    };
  }
}

export const CartEventsServiceModule = angular
  .module('acme.common.service.cart.events', [
    'acme.common.service.helpers',
    'acme.common.service.api',
    'acme.common.service.calendar',
    'acme.common.service.userPreferences',
    'acme.common.service.permissions',
    'acme.common.service.salesRules',
    'acme.common.filter.saleChannel',
  ])
  .constant('EventTicketDisplayMax', 5)
  .constant('EventAddOnDisplayMax', 5)
  .service('CartEventsService', CartEventsService).name;
